export const userTemplate = (params) =>
  [
    `<img src='${params.bookmarkable.photo_thumb_url}'>`,
    '<div>',
    I18n.t('web.bookmarks.create.success', {
      username: `${params.bookmarkable.firstname} ${params.bookmarkable.lastname}`,
      user_bookmarks_url: Routes.user_bookmarks_path(
        AlumniConnect.currentUser.id,
      ),
      user_bookmarks_label:
        AlumniConnect.currentNetwork.get('network_config').user_bookmarks_label,
    }),
    '</div>',
  ].join(' ');
